import { ElementType, PropsWithChildren, useEffect, useState } from 'react';
import { Item } from '../item/item';
import './style.module.scss';

interface IProps extends React.HTMLAttributes<HTMLHeadingElement> {
	tag?: ElementType;
}

export function Headline(props: PropsWithChildren<IProps>) {
	const { className, children, tag: Tag = 'h1' } = props;
	return (
		<Tag className={`${className}`} {...props}>
			{children}
		</Tag>
	);
}
